module.exports = __webpack_public_path__ + "img/wall_post.e65f59bf.svg";